import {
    leadMediaFragment,
    mediaFragment,
    segmentFragment,
} from "../fragments/contentItem";

export function contentItem(contentId, contentStatus = "") {
    return `
    query {
        contentItem(sourceId: "${contentId}", contentStatus:"${contentStatus}") {
            deck
            byline
            type
            wordcount: wordCount
            id
            corrections {
              correction
              epochDate
            }
            clarifications {
              clarification
              epochDate
            }
            mediaid: mediaId
            flag
            publishedAt
            updatedAt
            url
            externalLinks {
              type
              title
              url
            }
            shareHeadline
            highlights {
              bullets
              label
            }
            intlinks {
              url
              flag
              shareHeadline
              title
              type
            }
            authorDisplay
            authors {
              name
              title
              biography
              url
              photo {
                aspects {
                  ratio1x1 {
                    url
                  }
                }
              }
              links {
                title
                type
                url
              }
            }
            categories {
              id
              name
              type
              slug
              path
            }
            body {
              containsAudio
              containsVideo
              containsPhotogallery
              parsed
            }
            sponsor {
              external
              name
              image {
                title
                credit
                description
                aspects {
                  ratioCustom {
                    url
                  }
                }
              }
              label
              link: url
            }
            image {
              aspects {
                ratio16x9 {
                  url
                }
              }
            }
            leadMedia {
              ...leadMedia
            }
            jsonLD
            commentsEnabled
            section {
              path
              attributionLevels
              tracking {
                contentArea
                subSection1
                subSection2
                subSection3
                subSection4
              }
              social {
                commentsSection
                facebookPages
              }
            }
            advertising {
              exclusions
              categorization
            }
            tags {
              name
              type
            }
            concepts {
              type
              path
            }
            newsletter
            language
            title
            description
            editorialSource
            segment {
              media {
                ...media
              }
              episode {
                flag
                url
                title
                episode {
                  segments {
                    ...segment
                  }
                }
              }
            }
            episode {
              media {
                ...media
              }
              segments {
                ...segment
              }
            }
            photoGallery {
              aspectRatio
            }
          }
        }
        ${leadMediaFragment}
        ${mediaFragment}
        ${segmentFragment}
    `;
}
